// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.H7Vh_{overflow:hidden}.KWCpn{overflow:hidden;position:relative}.KWCpn.BSi_a{border-radius:16px}.MfsjF{position:absolute;top:0;left:0;right:0;bottom:0;background-color:rgba(40,40,99,.08);pointer-events:none;z-index:1}.DwH9A{position:absolute;top:0;left:0;right:0;bottom:0;display:flex;flex-direction:column;z-index:2}.mYhjx{top:32px;left:32px;right:32px;bottom:32px}.xQRDx{position:absolute;top:12px;right:12px;width:245px;z-index:3}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `H7Vh_`,
	"contentBox": `KWCpn`,
	"card": `BSi_a`,
	"overlay": `MfsjF`,
	"contentArea": `DwH9A`,
	"contentAreaCoverPage": `mYhjx`,
	"setupBrandContainer": `xQRDx`
};
export default ___CSS_LOADER_EXPORT___;
